import React from 'react';
import ReactGA from 'react-ga';

const Footer = () => {

  const links = [
    { label: 'Company', url: "https://www.privetechnologies.com" },
    { label: 'Privacy policy', url: "https://www.privetechnologies.com/privacy-policy/" },
    { label: 'Legal', url: "https://www.privetechnologies.com/legal/" },
  ];

  return (
    <div id="footer">
      <img className="logo" src="/img/prive-logo-white.svg" alt="" />
      <span>&copy; privé technologies</span>
      <span>
        {
          links
            .map((link) => {
              return (
                <ReactGA.OutboundLink key={link.label} eventLabel={link.label} to={link.url} target="_blank">
                  {link.label}
                </ReactGA.OutboundLink>
              );
            })
            .reduce((prev, currLink) => prev === null ? [currLink] : [prev, ' | ', currLink], null)
        }
      </span>
    </div>
  );
}

export default Footer;